<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="品牌名称" name="brand_name"></c-form-item>
                    <c-form-item type="checkbox" label="" name="state" :options="state" ></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_product_brand_add" color="sys" @click="add">新增品牌</c-button>
            </m-operate>

            <c-table ref="table">

                <c-table-column
                        label="品牌ID"
                        name="id"
                        width="70"
                >
                </c-table-column>

                <c-table-column
                        label="品牌LOGO"
                        name="logo"
						width="100"
                >
                    <template v-slot="{data}">
                        <c-image :src="data.logo" size="60"></c-image>
                    </template>
                </c-table-column>

                <c-table-column
                        label="品牌名称"
                        name="brand_name"
						width="200"
                >
                </c-table-column>

                <c-table-column
                        label="是否展示"
						width="80"
                >
					<template v-slot="{data}">
						<span v-if="data.is_show == 1" style="color:green">显示</span>
						<span v-else style="color:gray">隐藏</span>
					</template>
                </c-table-column>

                <c-table-column
                        label="品牌介绍"
                        name="remark"
						width="300"
                ></c-table-column>

                <c-table-column
                        label="是否启用"
						width="80"
                >
                    <template v-slot="{data}">
						<span v-if="data.state == 2" style="color:green">启用</span>
						<span v-else style="color:red">停用</span>
                    </template>
                </c-table-column>


                <c-table-column
                        type="sort"
                        label="排序"
                        power="b_product_brand_sort"
						width="200"
                        @sort="sortHandle"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_product_brand_edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button power="b_product_brand_edit"  v-if="data.state == 2" @click="startHandle('1', data)">停用</c-table-button>
                        <c-table-button power="b_product_brand_edit"  v-else-if="data.state == 1" @click="startHandle('2', data)">启用</c-table-button>
                        <c-table-button power="b_product_brand_edit"  v-if="data.is_show == 1" @click="showHandle('2', data)">隐藏</c-table-button>
                        <c-table-button power="b_product_brand_edit"  v-else-if="data.is_show == 2" @click="showHandle('1', data)">展示</c-table-button>
						<c-table-button power="b_product_brand_del" @click="deleteHandle('1', data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>

        <c-dialog ref="editDialog" :title="editState ? '编辑品牌' : '新增品牌'" width="600" @resolve="submit">
            <c-form ref="editForm">
                <c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="input" label="品牌名称" name="brand_name" required></c-form-item>
                <c-form-item type="image" label="品牌LOGO" name="logo" required></c-form-item>
                <c-form-item type="textarea" label="品牌介绍" name="remark"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>
    export default {
        name: 'm_product_brand',

        data() {
            return {
                editState: false,
                state: [{
                    name: '停用',
                    value: 1
                },{
                    name: '启用',
                    value: 2
                }
                ],
            }
        },

        mounted() {
            this.$refs.search.search();
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/product_brand/list',
                    data
                });
            },

            add() {
                this.editState = false;
                this.$refs.editForm.clear();
                this.$refs.editForm.set({brand_name:'',remark:''});
                this.$refs.editDialog.open();
            },

            edit(val) {
                this.editState = true;
                this.$refs.editForm.clear();
                this.$refs.editForm.set(val);
                this.$refs.editDialog.open();
            },


            sortHandle(row, type, next) {
                let submitData ={};
                submitData.type = type;
                if(type=='top' || type=='bottom'){
                    submitData.id = row.data.id;
                }
                if(type=='up'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.prev().data.id;
                    submitData.type = "";
                }
                if(type=='down'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.next().data.id;
                    submitData.type = "";
                }
                console.log(submitData)
                this.request({
                    url: '/product_brand/sort',
                    data: submitData,
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },

            startHandle(type, data) {
                this.$confirm({
                    text: `确定要${type == '1' ? '停用' : '启用'}该品牌吗？`,
                    resolve: () => {
                        this.request({
                            url: '/product_brand/updateState',
                            data: {
                                state: type,
                                id: data.id
                            },
                            loading: true,
                            success: () => {
                                this.$refs.table.update();
                            }
                        });
                    }
                });

            },

            showHandle(type, data) {
                this.$confirm({
                    text: `确定要${type == '1' ? '显示' : '隐藏'}该品牌吗？`,
                    resolve: () => {
                        this.request({
                            url: '/product_brand/updateShowState',
                            data: {
                                is_show: type,
                                id: data.id
                            },
                            loading: true,
                            success: () => {
                                this.$refs.table.update();
                            }
                        });
                    }
                });

            },
			
			deleteHandle(type, data) {
			    this.$confirm({
			        text: `确定要删除该品牌吗？`,
			        resolve: () => {
			            this.request({
			                url: '/product_brand/delete',
			                data: {
			                    id: data.id
			                },
			                loading: true,
			                success: () => {
								this.$message({
									icon: 'success',
								    text: '删除成功'
								});
			                    this.$refs.table.update();
			                }
			            });
			        }
			    });
			
			},

            submit(stop) {
                stop();
                this.$refs.editForm.submit({
                    url: this.editState ? '/product_brand/edit' : '/product_brand/add',
                    rule: {
                        brand_name: '请填写标签名称',
                        logo: '请选择logo',
                    },
                    success: (data, res) => {
                        this.$message({
							icon: 'success',
                            text: '保存成功'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    }
                });
            }
        }
    }
</script>